import type { TFunction } from 'i18next';
import { now } from '@/lib/clock';
import { daysUntil, formatNumber, formatTime } from '@/lib/format';

type Tv = TFunction<'deploy'>;

/** «Сегодня, 14:32», «Вчера, 18:10», «27 окт, 11:02» (the history's «when»). */
export function whenLabel(at: string, t: Tv, monthsShort: string[]): string {
  const days = -daysUntil(at, now());
  const time = formatTime(at);
  if (days <= 0) return t('when.today', { time });
  if (days === 1) return t('when.yesterday', { time });
  const parts = new Intl.DateTimeFormat('en-GB', { timeZone: 'Asia/Tashkent', day: 'numeric', month: 'numeric' }).formatToParts(new Date(at));
  const day = parts.find((p) => p.type === 'day')?.value ?? '';
  const month = Number(parts.find((p) => p.type === 'month')?.value ?? 1);
  return t('when.date', { day, month: monthsShort[month - 1] ?? '', time });
}

/** «99,98%» from a share (0.9998), with the given decimals. */
export function percent(share: number, digits: number): string {
  return `${formatNumber(share * 100, digits)}%`;
}

/** «1,9 с» from milliseconds. */
export function seconds(ms: number, t: Tv): string {
  return t('health.lcp_value', { value: formatNumber(ms / 1000, 1) });
}
